const DefaultMenuProps = {
  closeOnClick: false,
  closeOnContentClick: false,
  openOnClick: false,
  maxHeight: 'auto',
  offsetY: true,
  offsetOverflow: true,
  transition: false
}

export default DefaultMenuProps
